'use client';

import AnimatedToggle from '@ui/AnimatedToggle';
import Select from '@ui/Select';

export type ConditionValue = 'all' | 'new' | 'used';

const CONDITION_OPTIONS: { value: ConditionValue; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'new', label: 'New' },
  { value: 'used', label: 'Used' },
];

type SellerOption = { id: string; label: string; value: string };

// Shared "All / New / Used" condition toggle + "Seller type" select, rendered on
// both the search page and the vehicle landing pages. Each page maps its own
// filter state (search uses `useProductsPage`, vehicles use
// `useVehicleForSaleFilters`) onto these normalized props so the two stay
// visually identical without duplicating the control markup.
export default function ListingFilterControls({
  condition,
  onConditionChange,
  sellerValue,
  sellerOptions,
  onSellerChange,
  showSeller = true,
  sellerPlaceholder = 'Seller type',
  sellerEmptyLabel,
}: {
  condition: ConditionValue;
  onConditionChange: (value: ConditionValue) => void;
  sellerValue?: string;
  sellerOptions?: SellerOption[];
  onSellerChange?: (value: string) => void;
  showSeller?: boolean;
  sellerPlaceholder?: string;
  sellerEmptyLabel?: string;
}) {
  return (
    <div className="flex items-center gap-x-4">
      <AnimatedToggle
        options={CONDITION_OPTIONS}
        value={condition}
        onChange={onConditionChange}
        buttonWidth={65}
      />

      {showSeller && sellerOptions && (
        <Select
          placeholder={sellerPlaceholder}
          emptyLabel={sellerEmptyLabel}
          value={sellerValue ?? ''}
          options={sellerOptions}
          onChange={({ value }) => onSellerChange?.(value as string)}
          className="!h-[4.5rem] !w-[18rem] !rounded-[1.5rem] !border-none !bg-[#F1F1F1]"
          rounded
        />
      )}
    </div>
  );
}
